import { initializeApp, getApps, getApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDykKIhiu7KEiuT7ohS0EdP0RPAE2cBHeA",
  authDomain: "salew-app.firebaseapp.com",
  projectId: "salew-app",
  storageBucket: "salew-app.firebasestorage.app",
  messagingSenderId: "661825156843",
  appId: "1:661825156843:web:f9b59aeab0aa8d4e3530ae",
  measurementId: "G-J5R3K5Y894",
};

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

export function getFirebaseApp() {
  if (getApps().length > 0) {
    return getApp();
  }
  return initializeApp(firebaseConfig);
}

export function isSecureRuntimeForServiceWorker() {
  if (typeof window === "undefined") {
    return false;
  }
  const host = String(window.location?.hostname || "").toLowerCase();
  if (LOCAL_HOSTS.has(host)) {
    return true;
  }
  return Boolean(window.isSecureContext);
}

export function isPushRuntimeEligible() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  const hasNotifications = "Notification" in window;
  const hasServiceWorker = "serviceWorker" in navigator;
  return hasNotifications && hasServiceWorker && isSecureRuntimeForServiceWorker();
}
